import { useState, useEffect } from "react";
import { Grid } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { Mask } from "../assets";
import AppContainerButtons from "./AppContainerButtons";
import Stake from "./Stake";
import Unstake from "./Unstake";
import { useDispatch } from "react-redux";
import Withdraw from "./Withdraw";
import Header from "../components/Header";
import * as web3Actions from "../redux";
import { APP_CARD_BORDER, APP_STAKE_PAGE_TITLE } from "../utils/constants";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    // height: "61px",
    marginBottom: "25px",
    flexDirection: "column",
    marginTop: "50px",
  },

  nav: {
    background: theme.palette.cardBgColor,
    border: APP_CARD_BORDER,
    borderRadius: "40px",
    display: "flex",
    padding: "5px",
    marginBottom: "25px",
    "@media(max-width:550px)": {
      marginRight: "20px",
      width: "95%",
      justifyContent: "center",
    },
  },
}));
const AppContainer = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const [selected, setSelected] = useState("Stake");
  const changeStakeFunc = (label) => {
    setSelected(label);
  };
  const showComponent = (selected) => {
    if (selected == "Stake") {
      return <Stake />;
    } else if (selected == "Unstake") {
      return <Unstake />;
    } else if (selected == "Withdraw") {
      return <Withdraw />;
    }
  };

  useEffect(() => {
    document.querySelector("title").textContent = APP_STAKE_PAGE_TITLE;
    dispatch(web3Actions.getRewardPercentage());
    dispatch(web3Actions.getMinimumStakePeriod());
  }, []);
  return (
    <div style={{ position: "relative", height: "100%" }}>
      <img src={Mask} alt="app mask" className="maskImageStake" />
      <div className={classes.container}>
        <div className={classes.nav}>
          <AppContainerButtons
            label={"Stake"}
            selected={selected}
            changeStakeFunc={changeStakeFunc}
          />

          <AppContainerButtons
            label={"Unstake"}
            selected={selected}
            changeStakeFunc={changeStakeFunc}
          />

          <AppContainerButtons
            label={"Withdraw"}
            selected={selected}
            changeStakeFunc={changeStakeFunc}
          />
        </div>

        {showComponent(selected)}
      </div>
    </div>
  );
};

export default AppContainer;
